import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-teacher-card',
  templateUrl: './teacher-card.component.html',
})
export class TeacherCardComponent {
  @Input() name: string;
  @Input() displayName: string;
  @Input() title: string;
  @Input() teacherImageSource: string;

  backendUrl = environment.backendUrl;

  constructor() { }
}
